import { EndpointInterface } from '../../core'
import {
  DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER,
  ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER_ACTIVATE,
  ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER_DEACTIVATE,
  ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER_EMAILS,
  ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER_RESET_PASSWORD,
  ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USERS,
  ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USERS_CREDENTIALING,
} from '../constants'
import {
  AccessManagementClinicsUsersCredentialingGetQuery,
  AccessManagementClinicsUsersCredentialingGetResponse,
  AccessManagementClinicUsersGetResponse,
  AccessManagementClinicUserPatchPayload,
  AccessManagementClinicUsersPostPayload,
  AccessManagementClinicUserPutPayload,
  AccessManagementClinicUsersGetQuery,
  AccessManagementClinicUserGetResponse,
  AccessManagementClinicUserPatchResponse,
  AccessManagementClinicUsersPostResponse,
  AccessManagementClinicUserPutResponse,
} from '../types'

export const getAccessManagementClinicUsers =
  ({
    clinicId,
    query,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    clinicId: number
    query: AccessManagementClinicUsersGetQuery
    apiVersion?: string
  }): EndpointInterface<AccessManagementClinicUsersGetResponse> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USERS,
        params: [apiVersion, clinicId],
      },
      method: 'get',
      query,
    })

export const postAccessManagementClinicUsers =
  ({
    clinicId,
    data,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    clinicId: number
    data: AccessManagementClinicUsersPostPayload
    apiVersion?: string
  }): EndpointInterface<AccessManagementClinicUsersPostResponse> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USERS,
        params: [apiVersion, clinicId],
      },
      method: 'post',
      data,
    })

export const getAccessManagementClinicUser =
  ({
    clinicId,
    userId,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    clinicId: number
    userId: number
    apiVersion?: string
  }): EndpointInterface<AccessManagementClinicUserGetResponse> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER,
        params: [apiVersion, clinicId, userId],
      },
      method: 'get',
    })

export const patchAccessManagementClinicUser =
  ({
    clinicId,
    userId,
    data,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    clinicId: number
    userId: number
    data: AccessManagementClinicUserPatchPayload
    apiVersion?: string
  }): EndpointInterface<AccessManagementClinicUserPatchResponse> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER,
        params: [apiVersion, clinicId, userId],
      },
      method: 'patch',
      data,
    })

export const putAccessManagementClinicUser =
  ({
    clinicId,
    userId,
    data,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    clinicId: number
    userId: number
    data: AccessManagementClinicUserPutPayload
    apiVersion?: string
  }): EndpointInterface<AccessManagementClinicUserPutResponse> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER,
        params: [apiVersion, clinicId, userId],
      },
      method: 'put',
      data,
    })

export const deleteAccessManagementClinicUser =
  ({
    clinicId,
    userId,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    clinicId: number
    userId: number
    apiVersion?: string
  }): EndpointInterface<void> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER,
        params: [apiVersion, clinicId, userId],
      },
      method: 'delete',
    })

export const postAccessManagementClinicUserEmails =
  ({
    clinicId,
    userId,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    clinicId: number
    userId: number
    apiVersion?: string
  }): EndpointInterface<void> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER_EMAILS,
        params: [apiVersion, clinicId, userId],
      },
      method: 'post',
    })

export const postAccessManagementClinicUserDeactivate =
  ({
    clinicId,
    userId,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    clinicId: number
    userId: number
    apiVersion?: string
  }): EndpointInterface<void> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER_DEACTIVATE,
        params: [apiVersion, clinicId, userId],
      },
      method: 'post',
    })

export const postAccessManagementClinicUserActivate =
  ({
    clinicId,
    userId,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    clinicId: number
    userId: number
    apiVersion?: string
  }): EndpointInterface<void> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER_ACTIVATE,
        params: [apiVersion, clinicId, userId],
      },
      method: 'post',
    })

export const postAccessManagementClinicUserResetPassword =
  ({
    clinicId,
    userId,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    clinicId: number
    userId: number
    apiVersion?: string
  }): EndpointInterface<void> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USER_RESET_PASSWORD,
        params: [apiVersion, clinicId, userId],
      },
      method: 'post',
    })

export const getAccessManagementClinicUsersCredentialing =
  ({
    clinicId,
    query,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    clinicId: number
    query?: AccessManagementClinicsUsersCredentialingGetQuery
    apiVersion?: string
  }): EndpointInterface<AccessManagementClinicsUsersCredentialingGetResponse> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_USERS_CREDENTIALING,
        params: [apiVersion, clinicId],
      },
      method: 'get',
      query,
    })
